import { type SharedDocument, DocumentType } from 'types/Document';
import { makeStyles } from '@mui/styles';
import { downloadFileFromURL } from 'utils/file';
import { AudioPlayer } from 'components';
import DocumentPreview from './DocumentPreview';

const useStyles = makeStyles(() => ({
  audioControls: {
    borderRadius: 12,
    boxShadow: '0px 3px 8px 0px rgb(0 0 0 / 40%)',
    marginTop: 5,
  },
}), { name: 'AudioPreview' });

export type AudioPreviewProps = {
  document: SharedDocument;
  documentType: DocumentType;
};

export const AudioPreview = ({ document, documentType } : AudioPreviewProps) : JSX.Element => {
  const classes = useStyles();

  const handleDownload = () => downloadFileFromURL(document.blob.s3URL, document.name);  

  return (
    <div data-testid='audio-preview'>
      <DocumentPreview document={document} documentType={documentType} />

      <AudioPlayer
        id={document.blob.id || document.blob.key}
        className={classes.audioControls}
        url={document.blob.s3URL}
        handleDownload={handleDownload}
      />
    </div>
  );
};

export default AudioPreview;